export function shortenString(value, n) {
    if (value.length > n) {
        return value.slice(0, n) + '…';
    }
    return value;
}
